"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_compound_slider_1 = require("react-compound-slider");
var component_1 = require("./component");
var sliderStyle = {
    marginTop: '5%',
    position: 'relative',
    width: '100%',
};
var railStyle = {
    position: 'absolute',
    width: '100%',
    height: 10,
    borderRadius: 7,
    cursor: 'pointer',
    backgroundColor: 'rgb(155,155,155)',
};
var RangeSlider = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    var domain = [10, 20];
    return (react_1.default.createElement(react_compound_slider_1.Slider, { mode: 1, step: 5, domain: domain, rootStyle: sliderStyle, onChange: function (value) { return onChange(__spreadArray([], value)); }, values: value },
        react_1.default.createElement(react_compound_slider_1.Rail, null, function (_a) {
            var getRailProps = _a.getRailProps;
            return (react_1.default.createElement("div", __assign({ style: railStyle }, getRailProps())));
        }),
        react_1.default.createElement(react_compound_slider_1.Handles, null, function (_a) {
            var handles = _a.handles, getHandleProps = _a.getHandleProps;
            return (react_1.default.createElement("div", { className: "slider-handles" }, handles.map(function (handle) { return (react_1.default.createElement(component_1.Handle, { key: handle.id, handle: handle, domain: domain, getHandleProps: getHandleProps })); })));
        }),
        react_1.default.createElement(react_compound_slider_1.Tracks, { right: false }, function (_a) {
            var tracks = _a.tracks, getTrackProps = _a.getTrackProps;
            return (react_1.default.createElement("div", { className: "slider-tracks" }, tracks.map(function (_a) {
                var id = _a.id, source = _a.source, target = _a.target;
                return (react_1.default.createElement(component_1.Track, { key: id, source: source, target: target, getTrackProps: getTrackProps }));
            })));
        }),
        react_1.default.createElement(react_compound_slider_1.Ticks, { count: 3 }, function (_a) {
            var ticks = _a.ticks;
            return (react_1.default.createElement("div", { className: "slider-ticks" }, ticks.map(function (tick) { return (react_1.default.createElement(component_1.Tick, { key: tick.id, tick: tick, count: ticks.length })); })));
        })));
};
exports.default = RangeSlider;
